import React from "react";
import { Grid, TextField } from "@mui/material";
import { MultiFormatSelect, ReportSelect, SimpleSelect, SYSTEM_TYPE_OPTIONS } from "./clientFormHelpers";

const SystemStep = ({ formData, handleChange, reportsData }) => {
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="System Name" name="systemName" value={formData.systemName} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <SimpleSelect label="System Type" name="systemType" value={formData.systemType} onChange={handleChange} options={SYSTEM_TYPE_OPTIONS} />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Group Type" name="groupType" value={formData.groupType} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="GL Code" name="glCode" value={formData.glCode} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Process ID" name="processId" value={formData.processId} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Order Template" name="orderTemplate" type="number" value={formData.orderTemplate} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <ReportSelect
          label="Default Lab Report"
          name="defaultLabReport"
          value={formData.defaultLabReport}
          onChange={handleChange}
          reports={reportsData}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MultiFormatSelect
          label="Lab Report Format"
          name="labReportFileFormat"
          value={formData.labReportFileFormat || ""}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <ReportSelect
          label="Default Invoice Report"
          name="defaultInvoiceReport"
          value={formData.defaultInvoiceReport}
          onChange={handleChange}
          reports={reportsData}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MultiFormatSelect
          label="Invoice Report Format"
          name="invoiceReportFileFormat"
          value={formData.invoiceReportFileFormat || ""}
          onChange={handleChange}
        />
      </Grid>
    </Grid>
  );
};

export default SystemStep;
